import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Privacy = () => {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">Politique de confidentialité</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate">
          <p className="text-slate-600">
            <strong>Dashboard PRQC - Application interne</strong>
          </p>
          
          <h3 className="text-lg font-semibold mt-4">Collecte des données</h3>
          <p className="text-slate-600">
            Cette application collecte des données financières depuis votre compte QuickBooks Online 
            avec votre autorisation explicite. Les données collectées incluent:
          </p>
          <ul className="list-disc list-inside text-slate-600">
            <li>Écritures de journal</li>
            <li>Transactions (revenus et dépenses)</li>
            <li>Informations comptables générales</li>
          </ul>
          
          <h3 className="text-lg font-semibold mt-4">Utilisation des données</h3>
          <p className="text-slate-600">
            Les données sont utilisées exclusivement pour:
          </p>
          <ul className="list-disc list-inside text-slate-600">
            <li>Générer des rapports financiers personnalisés</li>
            <li>Calculer des indicateurs de performance (KPIs)</li>
            <li>Analyser la rentabilité par département</li>
          </ul>
          
          <h3 className="text-lg font-semibold mt-4">Stockage et sécurité</h3>
          <p className="text-slate-600">
            Les données sont stockées de manière sécurisée et ne sont jamais partagées avec des tiers. 
            Seuls les utilisateurs autorisés de Peinture Résidentielle QC ont accès aux données.
          </p>
          
          <h3 className="text-lg font-semibold mt-4">Vos droits</h3>
          <p className="text-slate-600">
            Vous pouvez à tout moment déconnecter votre compte QuickBooks et supprimer les données 
            importées via les paramètres de l&apos;application.
          </p>
          
          <h3 className="text-lg font-semibold mt-4">Contact</h3>
          <p className="text-slate-600">
            Pour toute question concernant cette politique, contactez l&apos;administrateur de 
            Peinture Résidentielle QC.
          </p>
          
          <p className="text-slate-500 text-sm mt-8">
            Dernière mise à jour: Février 2026
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Privacy;
